export const UserProgramStatuses = {
  NOT_STARTED: 'not_started',
  COMING_UP: 'coming_up',
  IN_PROGRESS: 'in_progress',
  EXTENDED: 'extended',
  ARCHIVED: 'archived',
  NON_ADHESION: 'non_adhesion',
} as const;

export type UserProgramStatus = (typeof UserProgramStatuses)[keyof typeof UserProgramStatuses];

export const USER_PROGRAM_STATUSES_VALUES: readonly UserProgramStatus[] = [
  UserProgramStatuses.NOT_STARTED,
  UserProgramStatuses.COMING_UP,
  UserProgramStatuses.IN_PROGRESS,
  UserProgramStatuses.EXTENDED,
  UserProgramStatuses.ARCHIVED,
  UserProgramStatuses.NON_ADHESION,
];

export const USER_PROGRAM_STATUSES_LABELS: Record<UserProgramStatus, string> = {
  [UserProgramStatuses.NOT_STARTED]: 'Non commencée',
  [UserProgramStatuses.COMING_UP]: 'À venir',
  [UserProgramStatuses.IN_PROGRESS]: 'En cours',
  [UserProgramStatuses.EXTENDED]: 'Prolongée',
  [UserProgramStatuses.ARCHIVED]: 'Archivée',
  [UserProgramStatuses.NON_ADHESION]: 'Non adhésion',
};

export type UserProgramStatusColor =
  | 'neutral'
  | 'positive'
  | 'accent'
  | 'negative'
  | 'warning'
  | 'primary';

export const USER_PROGRAM_STATUSES_COLORS: Record<UserProgramStatus, UserProgramStatusColor> = {
  [UserProgramStatuses.NOT_STARTED]: 'neutral',
  [UserProgramStatuses.COMING_UP]: 'neutral',
  [UserProgramStatuses.IN_PROGRESS]: 'accent',
  [UserProgramStatuses.EXTENDED]: 'warning',
  [UserProgramStatuses.ARCHIVED]: 'primary',
  [UserProgramStatuses.NON_ADHESION]: 'negative',
};

export function getProgramStatusColor(
  status: UserProgramStatus | null | undefined,
): UserProgramStatusColor {
  if (status == null) return 'neutral';
  return USER_PROGRAM_STATUSES_COLORS[status];
}

export function getProgramStatusLabel(status: UserProgramStatus | null | undefined): string {
  if (status == null) return '';
  return USER_PROGRAM_STATUSES_LABELS[status];
}

/**
 * User has access to the application when program status is one of these (excludes archived / non-adhesion).
 *
 * @see {@link doesProgramStatusAllowsAccess}.
 */
export const PROGRAM_STATUSES_THAT_ALLOW_ACCESS: readonly UserProgramStatus[] = [
  UserProgramStatuses.NOT_STARTED,
  UserProgramStatuses.COMING_UP,
  UserProgramStatuses.IN_PROGRESS,
  UserProgramStatuses.EXTENDED,
];

export function doesProgramStatusAllowsAccess(
  status: UserProgramStatus | null | undefined,
): boolean {
  return status != null && PROGRAM_STATUSES_THAT_ALLOW_ACCESS.includes(status);
}
